import { makeStyles } from "@mui/styles";

/**
 * Returns the styles object for ReportTable component.
 *
 * @param {Object} theme - The MUI theme object.
 * @return {Object} The styles object.
 */
export function ReportTableStyles(theme) {
  return {
    borderRadius: "5px",
    overflowY: "hidden",
    flexGrow: 1,
    position: "relative",

    maxHeight: "calc(100vh - 220px)",
    overflowY: "auto",

    [theme.breakpoints.down("sm")]: {
      maxHeight: "calc(100vh - 160px)",
      borderRadius: "3px",
    },

    [theme.breakpoints.up("md")]: {
      maxHeight: "calc(100vh - 180px)",
    },

    [theme.breakpoints.up("lg")]: {
      maxHeight: "calc(100vh - 140px)",
    },

    [theme.breakpoints.up("xl")]: {
      maxHeight: "calc(100vh - 100px)",
    },

    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#888",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#555",
    },
  };
}

/**
 * Returns the styles object for Backdrop component.
 *
 * @return {Object} The styles object.
 */
export function BackdropStyles() {
  return {
    zIndex: 9999,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  };
}

/**
 * Returns the styles object for CircularProgress component.
 *
 * @return {Object} The styles object.
 */
export function CircularProgressStyles() {
  return {
    zIndex: 10000,
    color: "#314BCA",
  };
}